<template>
  <div
    class="
      tw-absolute
      tw-right-1
      tw-w-16
      tw-h-full
      tw-flex
      tw-items-center
      tw-justify-end
      tw-opacity-0
      group-hover:tw-opacity-100
      tw-pointer-events-none
    "
    :class="background"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <SfButtonDs
      v-tooltip.html="tooltip"
      class="tw-pointer-events-auto"
      variant="tertiary"
      size="sm"
      icon-only
      icon-before="close"
      :aria-label="tooltip"
      :disabled="disabled"
      data-testid="unmark-button"
      :data-heap="`${trackingPrefix}-review-status-${trackingAction}`"
      @click.stop.prevent="unmark"
    />
  </div>
</template>

<script lang="ts" setup>
import { SfButtonDs } from '@silverfin/ui-components'

interface Props {
  tooltip: string
  background: string
  trackingPrefix: string
  trackingAction: string
  disabled?: boolean
}

withDefaults(defineProps<Props>(), {
  disabled: false,
})

const emit = defineEmits<{ unmark: []; onMouseEnter: []; onMouseLeave: [] }>()

function unmark() {
  emit('unmark')
}

function onMouseEnter() {
  emit('onMouseEnter')
}

function onMouseLeave() {
  emit('onMouseLeave')
}
</script>
